import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../../../layout/default";
import { useNavigate, useParams } from "react-router-dom";

const UserDetailView = () => {
  const navigate = useNavigate();
   const { id } = useParams(); // Extract `id` from URL parameters
  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    middle_name: "",
    phone_1: "",
    phone_2: "",
    // email: "",
    aadhar_number: "",
    pancard_number: "",
  });

  useEffect(() => {
    // Fetch user details to display
    const fetchUserDetails = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
          navigate("/shop/auths/login", { replace: true });
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_HOST}api/user-details/${id}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const userDetails = response.data;

        // Set user details to the state
        setUserDetails({
          first_name: userDetails.first_name,
          last_name: userDetails.last_name,
          middle_name: userDetails.middle_name || "",
          phone_1: userDetails.phone_1,
          phone_2: userDetails.phone_2 || "",
        //   email: userDetails.email,
          aadhar_number: userDetails.aadhar_number || "",
          pancard_number: userDetails.pancard_number || "",
        });
      } catch (error) {
        console.error("Error fetching user details:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load user details.',
        });
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const maskValue = (value) => {
    if (value.length === 12) {
      return value.replace(/(\d{4})(\d{4})(\d{4})/, "$1-****-****");
    } else if (value.length === 10) {
      return value.replace(/(\d{4})(\d{3})(\d{3})/, "$1-***-***");
    }
    return value;
  };

  return (
    <Layout title="User Details">
      <Container className="mt-4">
        <Row className="justify-content-md-center">
          <Col md={8}>
            <h3>User Details</h3>
            <Card>
              <Card.Body>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>First Name:</strong> {userDetails.first_name}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Last Name:</strong> {userDetails.last_name}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Middle Name:</strong> {userDetails.middle_name || "N/A"}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Phone Number 1:</strong> {userDetails.phone_1}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Phone Number 2:</strong> {userDetails.phone_2 || "N/A"}
                  </ListGroup.Item>
                  {/* <ListGroup.Item>
                    <strong>Email:</strong> {userDetails.email}
                  </ListGroup.Item> */}
                  <ListGroup.Item>
                    <strong>Aadhar Number:</strong> {maskValue(userDetails.aadhar_number)}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>PAN Card Number:</strong> {maskValue(userDetails.pancard_number)}
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default UserDetailView;
